/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendShopifyAppWelcomeEmailDto } from '../../models/send-shopify-app-welcome-email-dto';

export interface ShopifyAppControllerSendWelcomeEmail$Params {

/**
 * Store identifier for multi-tenant requests.
 */
  'terrific-store-id'?: string;
      body: SendShopifyAppWelcomeEmailDto
}

export function shopifyAppControllerSendWelcomeEmail(http: HttpClient, rootUrl: string, params: ShopifyAppControllerSendWelcomeEmail$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'status'?: 'queued' | 'already-sent';
}>> {
  const rb = new RequestBuilder(rootUrl, shopifyAppControllerSendWelcomeEmail.PATH, 'post');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'status'?: 'queued' | 'already-sent';
      }>;
    })
  );
}

shopifyAppControllerSendWelcomeEmail.PATH = '/api/v1/shopify-app/welcome-email';
